import { faEllipsisVertical, faPenToSquare, faUserGroup } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { KeycloakGroup } from "../../../model/CarbonExternalModels";
import { useCarbonDispatch } from "../../../store/carbonStore";
import UserGroupDelete from "../userGroupDelete/UserGroupDelete";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { Button } from "userful-chronos-common-ui/dist";
import { AppSliceActions } from "../../../store/app/appSlice";

interface IProps {
    group: KeycloakGroup;
}

export default function UserGroupActions(props: IProps) {
    const dispatch = useCarbonDispatch();

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isUserSuppressor) return null;

    return (
        <Dropdown>
            <Dropdown.Toggle className="source-actions-menu-toggle" as={Button}>
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {props.group && (
                    <>
                        <Dropdown.Item
                            onClick={() => {
                                dispatch(
                                    AppSliceActions.setAppView({
                                        type: "USER_GROUP",
                                        id: props.group.id,
                                    }),
                                );
                            }}
                        >
                            <div className="gcm-icon-dropdown-menu-icon-container">
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </div>
                            <p>Edit</p>
                        </Dropdown.Item>
                        {props.group.editable && (
                            <UserGroupDelete group={props.group} type="DROPDOWN" permissions={permissions} />
                        )}
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
